import Accueil from '../pages/accueil/accueil';
import { Route } from '../security/route';

export const routes: Route[] = [{ path: '/', Component: Accueil, exact: false }];
